import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loadCurrency: -1,
    loadPublicHoliday: -1,
  },
  currency: [],
  language: [],
  country: [],
  publicHolidays: [],
  metaPublicHolidays: {},
};

export default function reducer(state = initialState, action) {
  const { type, error, payload } = action;

  switch (type) {
    case ACTION_TYPES.CURRENCY_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadCurrency: 0,
        },
        error: null,
      };

    case ACTION_TYPES.CURRENCY_GET_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadCurrency: 1,
        },
        currency: payload.data,
      };

    case ACTION_TYPES.CURRENCY_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadCurrency: 2,
        },
        error,
      };

    case ACTION_TYPES.LANGUAGE_GET_SUCCEED:
      return {
        ...state,
        language: payload.data,
      };

    case ACTION_TYPES.COUNTRIES_GET_SUCCEED:
      return {
        ...state,
        country: payload.data,
      };

    // getPublicHolidays
    case ACTION_TYPES.GET_PUBLIC_HOLIDAY_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadPublicHoliday: 0,
        },
      };
    case ACTION_TYPES.GET_PUBLIC_HOLIDAY_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadPublicHoliday: 1,
        },
        publicHolidays: payload.data,
        metaPublicHolidays: payload.meta,
      };
    case ACTION_TYPES.GET_PUBLIC_HOLIDAY_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadPublicHoliday: 2,
        },
      };

    default:
      return state;
  }
}
